import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'html'})
export class HtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}
    transform(value: string, ...args: any[]) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}